import React from 'react'
import { IconButton } from '@material-ui/core'
import { t } from 'ttag'
import { ReactComponent as AddRoundedIcon } from '../../assets/v3/icons/add-rounded.svg'
import { darkBlue } from '../../styles/material-ui-theme-v2'
import { isRtl } from '../../i18nInit'

interface YumAddButtonProps {
  /**
   * Click handler function for the button
   */
  onClick: () => void

  /**
   * Button label text (defaults to "Add")
   */
  label?: string

  /**
   * ARIA label for accessibility (defaults to "add")
   */
  ariaLabel?: string

  /**
   * Additional styles to apply to the button
   */
  style?: React.CSSProperties
}

/**
 * Reusable button component with add icon and label text.
 * Supports RTL layout and customizable styling.
 */
export default function YumAddButton({ onClick, label = t`Add`, ariaLabel = 'add', style = {} }: YumAddButtonProps) {
  return (
    <IconButton aria-label={ariaLabel} onClick={onClick} style={{ borderRadius: '10px', ...style }}>
      <AddRoundedIcon
        style={{
          width: 24,
          height: 24,
        }}
      />
      <span
        style={{
          marginLeft: isRtl ? 0 : '10px',
          marginRight: !isRtl ? 0 : '10px',
          fontSize: '15px',
          color: darkBlue,
        }}
      >
        {label}
      </span>
    </IconButton>
  )
}
